import { v4 as uuidv4 } from "uuid";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
export const exportEditor = async (
  self,
  { factor, is_art_board_clip_path_on, container_el }
) => {
  self._checkNoProcessingTask();
  const layers_el = self._getLayersElThrowable();
  const working_layer_el = self._getWorkingLayerElThrowable();
  const art_board = self._getArtBoardThrowable();
  const art_board_clip_path_el = self._getArtBoardClipPathElThrowable();
  const view_box_width = art_board.getWidth();
  const view_box_height = art_board.getHeight();
  const view_port_width = view_box_width * factor;
  const view_port_height = view_box_height * factor;
  const export_el = layers_el.cloneNode(false);
  export_el.setAttributeNS(null, "width", `${view_port_width}`);
  export_el.setAttributeNS(null, "height", `${view_port_height}`);
  export_el.setAttributeNS(
    null,
    "viewBox",
    `0 0 ${view_box_width} ${view_box_height}`
  );
  const clone_working_layer_el = await CommonNS.UtilNS.deepCloneNode(
    working_layer_el
  );
  if (is_art_board_clip_path_on) {
    const clone_art_board_clip_path_el = await CommonNS.UtilNS.deepCloneNode(
      art_board_clip_path_el
    );
    clone_art_board_clip_path_el.setAttributeNS(
      null,
      "id",
      `${CommonNS.ConstNS.DATA_KEY_ROLE}__art-board-clip-path__${uuidv4()}`
    );
    const defs_el = self._document.createElementNS(
      CommonNS.ConstNS.SVG_NAMESPACE,
      "defs"
    );
    defs_el.appendChild(clone_art_board_clip_path_el);
    export_el.appendChild(defs_el);
    clone_working_layer_el.setAttributeNS(
      null,
      "clip-path",
      `url(#${clone_art_board_clip_path_el.id})`
    );
  } else {
    clone_working_layer_el.removeAttributeNS(null, "clip-path");
  }
  export_el.appendChild(clone_working_layer_el);
  container_el.appendChild(export_el);
  const stroke = new StrokeNS.ModelNS.Stroke({
    svg_el: self._svg_el,
    getCTM: () => {
      const ctm = clone_working_layer_el.getCTM();
      if (ctm == null) {
        throw new Error(`clone_working_layer_el 의 CTM 을 구할 수 없습니다.`);
      }
      return ctm;
    },
  });
  const stroke_sync = new StrokeNS.ModelNS.StrokeSync({
    el: clone_working_layer_el,
    SVGGraphicsElement: self._window.SVGGraphicsElement,
    stroke,
  });
  stroke_sync.sync();
  container_el.removeChild(export_el);
  return export_el;
};
